import { render, staticRenderFns } from "./NewSliderRight.vue?vue&type=template&id=0c203885&scoped=true&"
import script from "./NewSliderRight.vue?vue&type=script&lang=js&"
export * from "./NewSliderRight.vue?vue&type=script&lang=js&"
import style0 from "./NewSliderRight.vue?vue&type=style&index=0&id=0c203885&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c203885",
  null
  
)

export default component.exports